/* eslint-disable @typescript-eslint/quotes */
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { serverUrl } from "src/app/serverUrl";

@Injectable({
  providedIn: "root",
})
export class SubCategoryService {
  constructor(private httpClient: HttpClient) {}

  async getSubCategories(catId: any) {
    const formData = new FormData();
    formData.append("catId", catId);
    const url = (await serverUrl) + "open/getFaqSubCategories";
    return new Promise((resolve) => {
      this.httpClient
        .post(url, formData)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  async saveSubCategory(catId: any, sucId: any, sucNameEng: any, sucNameMar: any, flag: any) {
    const formData = new FormData();
    formData.append("catId", catId);

    if (flag === "E") {
      formData.append("sucId", sucId);
    }
    formData.append("sucNameEng", sucNameEng);
    formData.append("sucNameMar", sucNameMar);
    const url = (await serverUrl) + "open/saveFaqSubCategory";
    return new Promise((resolve) => {
      this.httpClient
        .post(url, formData, { responseType: "text" })
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  getSubCategoriesV1(catId: any): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("catId", catId);
    return this.httpClient.post<any>(serverUrl + "open/getFaqSubCategories", queryParams, {
      headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
    });
  }

  saveSubCategoryV1(catId: any, sucId: any, sucNameEng: any, sucNameMar: any, flag: any): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("catId", catId);
    if (flag === "E") {
      queryParams = queryParams.append("sucId", sucId);
    }

    queryParams = queryParams.append("sucNameEng", `${sucNameEng}`);
    queryParams = queryParams.append("sucNameMar", `${sucNameMar}`);
    return this.httpClient.post<any>(serverUrl + "open/saveFaqSubCategory", queryParams, {
      headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
      responseType: "text" as "json",
    });
  }
}
